import { FC } from "react";

import {
  FilterFreeText,
  FilterNumberBetween,
  FilterNumberComparison,
  FilterTime,
} from "@ryde/controls";
import { FIELD_TYPE_IDS, IFilterDetail } from "@ryde/shared";

interface IPageHeaderFiltersItem {
  filter: IFilterDetail;
}

export const PageHeaderFiltersItem: FC<IPageHeaderFiltersItem> = ({
  filter,
}) => {
  switch (filter.control.filterFieldTypeId) {
    case FIELD_TYPE_IDS.FILTER.time:
      return (
        <FilterTime
          key={filter.filterId}
          customFieldId={Number(filter.filterId)}
          value={filter.filterValue}
        />
      );
    case FIELD_TYPE_IDS.FILTER.number_between:
      return (
        <FilterNumberBetween
          key={filter.filterId}
          customFieldId={Number(filter.filterId)}
          control={filter.control}
          value={filter.filterValue}
        />
      );
    case FIELD_TYPE_IDS.FILTER.number_comparison:
      return (
        <FilterNumberComparison
          key={filter.filterId}
          customFieldId={Number(filter.filterId)}
          value={filter.filterValue}
        />
      );
    case FIELD_TYPE_IDS.FILTER.free_text:
      return (
        <FilterFreeText
          key={filter.filterId}
          customFieldId={Number(filter.filterId)}
          // filterAttributes=
          value={filter.filterValue}
        />
      );
    default:
      return null;
  }
};
